import { Component } from 'react';
import { Button } from '../components/ui/button';
import { AuthContext } from '../context/AuthContext';

// Component to show error gracefully when in production instead of blanking

class ErrorBoundary extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("ErrorBoundary caught an error", error, errorInfo);
        this.setState({ errorInfo: errorInfo });
    }

    render() {
        const auth = this.props.auth || this.context;
        if (this.state.hasError) {
            // Check if this is a network-related error
            const isNetworkError =
                this.state.error?.message?.includes("Network Error") ||
                this.state.error?.isOfflineError ||
                !navigator.onLine;

            if (isNetworkError) {
                return (
                    <div className="mx-12 my-8">
                        <h1 className='font-medium text-2xl text-destructive'>Anslutningsfel</h1>
                        <p className='text-muted-foreground mb-8'>
                            Det ser ut som att du inte har internet just nu. Kontrollera din anslutning och försök igen.
                        </p>
                        <Button
                            variant='secondary'
                            onClick={() => window.location.reload()}
                        >
                            Försök igen
                        </Button>
                    </div>
                );
            }
            
            return (
                <div className="mx-12 my-8">
                    <h1 className='font-medium text-2xl text-destructive'>Ett oväntat fel har inträffat.</h1>
                    <p className='text-muted-foreground mb-8'>Skicka med följande information tillsammans med buggrapport:</p>
                    <div className='flex flex-row gap-6 mb-3'>
                        <p>Super: {auth?.user?.superadmin ? '1' : '0'}</p>
                        <p>Bunny: {auth?.user?.bunnyadmin ? '1' : '0'}</p>
                        <p>Club: {auth?.user?.roleInClub === 'admin' ? '1' : '0'}</p>
                        <p>Member of: {auth?.user?.memberOfClub}</p>
                    </div>
                    <p>{this.state.error && this.state.error.toString()}</p>
                    <p>{this.state.errorInfo && this.state.errorInfo.componentStack}</p>
                    <a href='/upcoming' className='mt-8'>
                        <Button variant='secondary'>Tillbaka till tävlingar</Button>
                    </a>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
